import { render, staticRenderFns } from "./Procedures.vue?vue&type=template&id=7d83fb29&scoped=true"
import script from "./Procedures.vue?vue&type=script&lang=ts"
export * from "./Procedures.vue?vue&type=script&lang=ts"
import style0 from "./Procedures.vue?vue&type=style&index=0&id=7d83fb29&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d83fb29",
  null
  
)

export default component.exports